<template>
  <div v-if="visible" class="mobile-menu" aria-label="Vehicle navigation">
    <nav class="mobile-menu__nav">
      <div v-for="category in categories" :key="category.id" class="mobile-menu__category">
        <span>{{ category.name }}</span>
        <router-link
          v-for="product in (category.products || [])"
          :key="product.id || product.name"
          :to="`/products/${product.id || slugify(product.name)}`"
          @click.native="$emit('close')"
        >{{ product.name }}</router-link>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'MobileMenu',
  props: {
    visible: Boolean,
    categories: { type: Array, default: () => [] }
  },
  methods: {
    slugify (value) {
      return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-')
    }
  }
}
</script>
